import React from 'react';
import store from "../store";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import firebase from "firebase/app";
import { Link } from "react-router-dom";
import * as STATIC from '../config/static';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import Toolbar from '@material-ui/core/Toolbar';
import ButtonBase from '@material-ui/core/ButtonBase';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import HomeIcon from '@material-ui/icons/Home';
import FacebookIcon from '@material-ui/icons/Facebook';
class Footer extends React.Component {
    state = {

    };


    toggleLang(LANG)
    {
      let nLANG = 'en';
      if(LANG == 'en')
      nLANG = 'vi';
      this.props.i18n.changeLanguage(nLANG);
      localStorage.setItem('LANG',nLANG);
      store.dispatch({ type: 'LANG', LANG: nLANG });
    }

    render() {
        const { classes } = this.props;
        let width = this.props.width;
        if(this.props.width>980)
        width = 980;
        let HC = STATIC.calSize;
        let fLarge = width * 0.06;
        let fTitle = width * 0.04;
        let fNormal = width * 0.03;
        let fSmall = width * 0.02;
        let fSmaller = width * 0.01;

        let LANG = store.getState().LANG;
        let pathName = window.location.pathname.toLowerCase();
        return (
          <div>

          <div style={{display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'center',color:'white'}}>
            <div style={{backgroundColor:STATIC.MyStyle.BG_TRANS,display:'flex',flexDirection:'row',alignItems:'center',maxWidth:STATIC.DWIDTH,width:width,padding:HC(20,width)+'px '+HC(10,width)+'px'}}>
              <div style={{fontSize:fSmaller}}>Copyright © VE.GIA.RE 2019</div>
            </div>
            <div>
                <a href='https://www.facebook.com/vegiare.tourgiare/' target='_blank'><FacebookIcon style={{fontSize:fNormal,color:'white'}} /></a>
            </div>
          </div>
        </div>

        );
    }
}

Footer.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(STATIC.styles)(STATIC.translate('common')(Footer));
